import 'svelte/internal/disclose-version';

App[$.FILENAME] = 'src/App.svelte';

import * as $ from 'svelte/internal/client';
import Header from "./components/Header.svelte";
import Footer from "./components/Footer.svelte";
import Toasts from "./components/Toasts.svelte";
import Home from "./pages/Home.svelte";
import Search from "./pages/Search.svelte";
import RestaurantDetail from "./pages/RestaurantDetail.svelte";
import Login from "./pages/Login.svelte";
import Register from "./pages/Register.svelte";
import Verify from "./pages/Verify.svelte";
import Forgot from "./pages/Forgot.svelte";
import Reset from "./pages/Reset.svelte";
import Profile from "./pages/Profile.svelte";
import Admin from "./pages/Admin.svelte";
import AdminUsers from "./pages/AdminUsers.svelte";
import AdminIngest from "./pages/AdminIngest.svelte";
import AdminRefresh from "./pages/AdminRefresh.svelte";
import AdminMatches from "./pages/AdminMatches.svelte";
import AdminRestaurantForm from "./pages/AdminRestaurantForm.svelte";
import NotFound from "./pages/NotFound.svelte";
import { route } from "./lib/router.svelte.js";

var root = $.add_locations($.from_html(`<a class="skip svelte-1n46o8q" href="#main">Skip to content</a> <!> <main id="main" class="svelte-1n46o8q"><div class="shell svelte-1n46o8q"><!></div></main> <!> <!>`, 1), App[$.FILENAME], [[48, 0], [52, 0, [[53, 2]]]]);

const $$css = {
	hash: 'svelte-1n46o8q',
	code: '\n  .skip.svelte-1n46o8q {\n    position: absolute;\n    left: -9999px;\n    top: 8px;\n    background: var(--accent);\n    color: #fff;\n    padding: 10px 18px;\n    border-radius: var(--radius-pill);\n    z-index: 999;\n  }\n  .skip.svelte-1n46o8q:focus { left: 16px; }\n\n  main.svelte-1n46o8q { min-height: 60vh; }\n  .shell.svelte-1n46o8q {\n    max-width: var(--max-w);\n    margin: 0 auto;\n    padding: 0 20px 48px;\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function App($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, App);
	$.append_styles($$anchor, $$css);

	const PAGES = {
		home: Home,
		search: Search,
		restaurant: RestaurantDetail,
		login: Login,
		register: Register,
		verify: Verify,
		forgot: Forgot,
		reset: Reset,
		profile: Profile,
		admin: Admin,
		adminUsers: AdminUsers,
		adminIngest: AdminIngest,
		adminRefresh: AdminRefresh,
		adminMatches: AdminMatches,
		adminRestaurantNew: AdminRestaurantForm,
		adminRestaurantEdit: AdminRestaurantForm,
		notFound: NotFound
	};

	const Page = $.tag($.derived(() => PAGES[route.name] ?? NotFound), 'Page');
	var $$exports = { ...$.legacy_api() };
	var fragment = root();
	var node = $.sibling($.first_child(fragment), 2);

	$.add_svelte_meta(() => Header(node, {}), 'component', App, 50, 0, { componentTag: 'Header' });

	var main = $.sibling(node, 2);
	var div = $.child(main);
	var node_1 = $.child(div);

	$.add_svelte_meta(
		() => $.key(node_1, () => route.path, ($$anchor) => {
			var fragment_1 = $.comment();
			var node_2 = $.first_child(fragment_1);

			$.add_svelte_meta(
				() => $.component(node_2, () => $.get(Page), ($$anchor, Page_1) => {
					Page_1($$anchor, {});
				}),
				'component',
				App,
				55,
				6,
				{ componentTag: 'Page' }
			);

			$.append($$anchor, fragment_1);
		}),
		'key',
		App,
		54,
		4
	);

	$.reset(div);
	$.reset(main);

	var node_3 = $.sibling(main, 2);

	$.add_svelte_meta(() => Footer(node_3, {}), 'component', App, 60, 0, { componentTag: 'Footer' });

	var node_4 = $.sibling(node_3, 2);

	$.add_svelte_meta(() => Toasts(node_4, {}), 'component', App, 61, 0, { componentTag: 'Toasts' });
	$.append($$anchor, fragment);

	return $.pop($$exports);
}